import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13e0a7bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fb-trailer-side-selector" }
const _hoisted_2 = {
  class: "fb-svg trailer-back",
  style: {"enable-background":"new 0 0 237 347"},
  version: "1.1",
  viewBox: "0 0 237 347",
  x: "0px",
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  y: "0px"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "fb-path chassis",
  d: "M213,347c-1.7,0-3-1.3-3-3v-14h23v14c0,1.7-1.3,3-3,3H213z M185,347c-1.7,0-3-1.3-3-3v-14h24v14 c0,1.7-1.3,3-3,3H185z M34,347c-1.7,0-3-1.3-3-3v-14h23v14c0,1.7-1.3,3-3,3H34z M6,347c-1.7,0-3-1.3-3-3v-14h24v14c0,1.7-1.3,3-3,3 H6z M0,326v-12h58v-28H0v-16h237v16h-58v28h58v12H0z M162,314v-28h-26v14c0,1.1-0.9,2-2,2h-31c-1.1,0-2-0.9-2-2v-14H75v28H162z M210,311v-19c0-1.7,1.3-3,3-3h17c1.7,0,3,1.3,3,3v19H210z M182,311v-19c0-1.7,1.3-3,3-3h18c1.7,0,3,1.3,3,3v19H182z M31,311v-19 c0-1.7,1.3-3,3-3h17c1.7,0,3,1.3,3,3v19H31z M3,311v-19c0-1.7,1.3-3,3-3h18c1.7,0,3,1.3,3,3v19H3z"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "fb-path box",
  d: "M237,272H0V4c0-2.2,1.8-4,4-4h229c2.2,0,4,1.8,4,4V272L237,272L237,272z M6,4C4.9,4,4,4.9,4,6v262h229 V6c0-1.1-0.9-2-2-2H6z"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "fb-path doors",
  d: "M6,4h225c1.1,0,2,0.9,2,2v262H4V6C4,4.9,4.9,4,6,4z"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "fb-path seal",
  d: "M117,9h3v253h-3V9z"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "fb-path hinges",
  d: "M228,215c-1.1,0-2-0.9-2-2v-9c0-1.1,0.9-2,2-2h9v13H228z M0,215v-13h8c1.1,0,2,0.9,2,2v9 c0,1.1-0.9,2-2,2H0z M228,142c-1.1,0-2-0.9-2-2v-9c0-1.1,0.9-2,2-2h9v13H228z M0,142v-13h8c1.1,0,2,0.9,2,2v9c0,1.1-0.9,2-2,2H0z M228,70c-1.1,0-2-0.9-2-2v-9c0-1.1,0.9-2,2-2h9v13H228z M0,70V57h8c1.1,0,2,0.9,2,2v9c0,1.1-0.9,2-2,2H0z"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "fb-path laches",
  d: "M125,262V9h5v253H125z M107,262v-21H95v2c0,0.6-0.4,1-1,1h-5c-0.6,0-1-0.4-1-1v-2H62 c-1.1,0-2-0.9-2-2v-1c0-1.1,0.9-2,2-2h26v-3c0-0.6,0.4-1,1-1h5c0.6,0,1,0.4,1,1v3h12V9h4v253H107z M143,244c-0.6,0-1-0.4-1-1v-2h-12 v-5h12v-3c0-0.6,0.4-1,1-1h5c0.6,0,1,0.4,1,1v3h25c1.1,0,2,0.9,2,2v1c0,1.1-0.9,2-2,2h-25v2c0,0.6-0.4,1-1,1H143z"
}, null, -1))
const _hoisted_9 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-down" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-down" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrailerDamageLayout = _resolveComponent("TrailerDamageLayout")!

  return (_openBlock(), _createBlock(_component_TrailerDamageLayout, null, {
    damageType: _withCtx(() => [
      _createTextVNode("(Tires & Wheels)")
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_9)),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-outline-dark input-radius fb-btn-selector bottom-left", _ctx.driverSide]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.enterDriverSide && _ctx.enterDriverSide(...args)))
        }, _hoisted_11, 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-outline-dark input-radius fb-btn-selector bottom-right", _ctx.passengerSide]),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.enterPassengerSide && _ctx.enterPassengerSide(...args)))
        }, _hoisted_13, 2)
      ])
    ]),
    _: 1
  }))
}